export const useBarcodeScanner = {
  computed: {
    deviceWasEnabled() {
      return !!(this.readerWasRunned
        && this.selectedMode === "device");
    },
  },
  methods: {
    printBarcode() {
      setTimeout(() => {
        this.detectedBarcode = this.$refs.barcodeInput.value;
      }, 500);
    },
    stopScannerDevice() {
      if (this.deviceWasEnabled) {
        document.removeEventListener("keypress", this._returnToBarcodeInput);
        document.removeEventListener("paste", this._pasteBarcode);
      }
    },
    startScannerDevice() {
      this.readerWasRunned = true;
      this.selectedMode = "device";
      document.addEventListener("keypress", this._returnToBarcodeInput);
      document.addEventListener("paste", this._pasteBarcode);
      this.$refs.barcodeInput.focus();
    },
    _pasteBarcode(event) {
      const value = event.clipboardData.getData('text/plain');
      this.$refs.barcodeInput.value = value;
    },
    _returnToBarcodeInput(e) {
      if (e.target.tagName !== "INPUT") {
        this.$refs.barcodeInput.focus();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/stock/mixins/useBarcodeScanner.js